import React, { Component } from "react";
import PropTypes from "prop-types";
import { Calendar as CalendarDHX } from "dhx-suite";
import "../../../dhtmlx/codebase/suite.css";
import "./Calendar.css";

const hoy = new Date();
class Calendar extends Component {
	componentDidMount() {
		let { css, value, weekNumbers, timeFormat, toogleDateRange, dateFormat } = this.props;
		this.calendar = new CalendarDHX(this.el, {
			css: css,
			weekNumbers: weekNumbers,
			timePicker: false,
			timeFormat: timeFormat,
			range: true,
    	value: value,
			dateFormat:dateFormat,
			weekStart: "monday",
			mark: function (date) {
        if (date.toLocaleDateString() === hoy.toLocaleDateString()) {
            return "highlight-date";
        }
    	},
		 	disabledDates: function (date) {
        const disabled = {
            0: true,
            1: true,
            2: true,
            3: true,
            4: true,
            5: true,
            6: true,
        }
        if(hoy < date){
            return disabled[date.getDay()];
        }
        return '';
        
    },
		});
		this.calendar.events.on("change",()=>{
			toogleDateRange(this.calendar.getValue());
		});
	}
	componentWillUnmount() {
		this.calendar && this.calendar.destructor();
	}
	render() {
		return <div ref={el => (this.el = el)}></div>;
	}
}

function CalendarProps (props) {
		return (
			<Calendar
				css={"dhx_widget--bordered"}
				weekNumbers={true}
				timeFormat={24}
				dateFormat={"%Y-%m-%d"}
				thisMonthOnly={true}
				range={true}
				value={props.value}
				toogleDateRange={props.toogleDateRange}
			/>
		);
}

CalendarProps.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
	css: PropTypes.string,
	mark: PropTypes.func,
	disabledDates: PropTypes.func,
	weekStart: PropTypes.oneOf(["monday", "sunday"]),
	weekNumbers: PropTypes.bool,
	mode: PropTypes.oneOf(["calendar", "year", "month", "timepicker"]),
	timePicker: PropTypes.bool,
	dateFormat: PropTypes.string,
	timeFormat: PropTypes.oneOf([24, 12]),
	thisMonthOnly: PropTypes.bool,
	width: PropTypes.string,
	range: PropTypes.bool,
};

export default CalendarProps;